import React, { Component } from 'react'
import moment from 'moment'
import { Route, Switch, BrowserRouter as Router } from 'react-router-dom'
import { Base64 } from 'js-base64'
import queryString from 'query-string'

import { PaginationContext } from '../../context/pagination'
import { NextDisabledContext } from '../../context/nextDisabled'

import Registration1 from './registration_p1'
import Registration2 from './registration_p2'
import Registration3 from './registration_p3'
import Registration4 from './registration_p4'
import AssessmentJPMC from './assessment_jpmc'
import Screener from './screener'
import FetchWrapper from '../../utils/fetch_wrapper'

import config from '../../utils/config'
import versionFile from '../../utils/version'

class Registration extends Component {
  constructor(props) {
    super(props)
    this.state = { 
      verError: false,
      verErrorMessage: '',
      loading: true,
      nextDisabled: false,
      invalidParticipant: false,
    }
    this.updateActivePage = this._updateActivePage.bind(this)
    this.getRegistrationConfig = this._getRegistrationConfig.bind(this)
    this.authentication = this._authentication.bind(this)
    this.verifyEmail = this._verifyEmail.bind(this)
    this.isEligible = this._isEligible.bind(this)
    this.nextPage = this._nextPage.bind(this, props.history)
    this.replaceHistoryState = this._replaceHistoryState.bind(this)
    document.title = "Registration"
  }

  static getPageCount() {
    return 3
  }

  _updateActivePage(n) {
    this.context.updateActivePage(this.props.match.path, n)
  }

  async componentDidMount() {
    const plId = queryString.parse(window.location.search).plId
    if (!plId && (window.location.pathname === '/register/2' || window.location.pathname === '/register/3')) {
      this.props.error()
    } else if (plId && (window.location.pathname === '/register/2' || window.location.pathname === '/register/3')) {
      await this.props.getStepCompleted(plId)
    }
    this.setState({ loading: false })
  }

  componentDidUpdate() {
    if (this.shouldRedirect()) {
      let result = this.props.setShouldRedirect(true)
      if (result) this.setState({ nextDisabled: false })
    } else {
      this.props.setShouldRedirect(false)
    }
  }

  _backPage(history, cur) {
    const newHistory = this.setHistory(this.state, history)
    this.setState({
      verError: false
    })
    switch(cur) {
      case '/1':
        return undefined
      case '/2':
        return history.push('/1' + window.location.search, newHistory)
      case '/3':
        return history.push('/2' + window.location.search, newHistory)
      default: return null
    }
  }

  async _nextPage(history, cur, state) {
    const params = queryString.parse(window.location.search)
    let newHistory = this.setHistory(state, history)
    let verified = false
    let emailVerified = false
    let configVerified = false
    if (this.state.nextDisabled) return null
    this.setState({ verError: false })
    switch(cur) {
      case '/1':
        this.setState({
          nextDisabled: true
        }, async () => {
          verified = await this.authentication(state, history)
          if(verified) {
            newHistory = {
              ...newHistory,
              ...verified,
            }
            configVerified = await this.getRegistrationConfig(verified.plId)
            if(configVerified) {
              newHistory = {
                ...newHistory,
                ...configVerified,
              }
              const response = await this.props.getStepCompleted(verified.plId)
              this.setState({ nextDisabled: false })
              if (response.message) {
                this.setState({ 
                  verError: true, 
                  verErrorMessage: response.message
                })
                return
              }
              if (response) return this.props.setShouldRedirect(true)
              if(this.props.collectEmail) {
                emailVerified = await this.verifyEmail(history, verified.plId)
                if(emailVerified) {
                  await this.collectEmail(history, verified.plId)
                  if (verified.assessment === 'JPMC') {
                    if (params.plId) { 
                      return history.push('/assessment' + window.location.search, newHistory)
                    }
                    return history.push('/assessment?regCode=' + history.location.state.rCode.value.trim() + '&plId=' + verified.plId, newHistory)
                  }
                  if (verified.assessment === 'true') {
                    if (params.plId) { 
                      return history.push('/screener' + window.location.search, newHistory)
                    }
                    return history.push('/screener?regCode=' + history.location.state.rCode.value.trim() + '&plId=' + verified.plId, newHistory)
                  }
                  if (params.plId) return history.push('/2' + window.location.search, newHistory)
                    return history.push('/2?regCode=' + history.location.state.rCode.value.trim() + '&plId=' + verified.plId, newHistory)
                } else {
                  this.setState({ nextDisabled: false })
                }
              } else if (newHistory.email !== undefined) {
                newHistory.email.value = ''
                if (verified.assessment === 'JPMC') {
                  if (params.plId) { 
                    return history.push('/assessment' + window.location.search, newHistory)
                  }
                  return history.push('/assessment?regCode=' + history.location.state.rCode.value.trim() + '&plId=' + verified.plId, newHistory)
                }
                if (verified.assessment === 'true') {
                  if (params.plId) { 
                    return history.push('/screener' + window.location.search, newHistory)
                  }
                  return history.push('/screener?regCode=' + history.location.state.rCode.value.trim() + '&plId=' + verified.plId, newHistory)
                }
                if (params.plId) return history.push('/2' + window.location.search, newHistory)
                  return history.push('/2?regCode=' + history.location.state.rCode.value.trim() + '&plId=' + verified.plId, newHistory)
              } else {
                this.setState({ nextDisabled: false })
              }
            } else {
              this.setState({ nextDisabled: false })
            }
          } else {
            this.setState({ nextDisabled: false })
          } 
        })
        break
      case '/assessment':
        const response = await this.props.getStepCompleted(params.plId)
        this.setState({ nextDisabled: false })
        if (response) return this.props.setShouldRedirect(true)
        return history.push('/2' + history.location.search, newHistory)
      case '/screener':
        const resp = await this.props.getStepCompleted(params.plId)
        this.setState({ nextDisabled: false })
        if (resp) return this.props.setShouldRedirect(true)
        return history.push('/2' + history.location.search, newHistory)
      case '/2':
        if(this.props.collectEmail) {
          await this.collectEmail(history, queryString.parse(window.location.search).plId)
        } 
        return history.push('/3' + history.location.search, newHistory)
      case '/3':
        this.setState({
          nextDisabled: true
        }, async () => {
          await this.props.getStepCompleted(params.plId)
          if (window.location.pathname !== '/register/3') return null
          verified = await this.processRegistration(state, history)
          if(verified) {
            return this.props.next()
          }
        })
        break
      default: break
    }
  }

  async _getRegistrationConfig(plId) {
    try { 
      let response = await FetchWrapper.fetch(config.endpoint_get_registration_configuration + '&plId=' + plId, {
        method: 'get',
        headers: {
          'Content-Type': 'application/json',
        }
      })
      
      this.setState({ verError: false })
      return response.data
    } catch(error) {
      this.setState({ verError: error.statusCode || true})
      return false
    }
  }

  async _authentication(state, history) {
    const { lName, dob, rCode, email, verCode, spouseSelection } = history.location.state
    let params = { 
      'lName': lName.value.trim(),
      'dob': dob.value,
      'regCode': rCode.value.trim(),
      'email': email != null ? email.value.trim() : '',
      'isSpouse': spouseSelection.value,
      'validation': this.props.ValidateOn === 'GENERIC' && this.props.UseLeadingZeros === 'false'
                ? verCode.value.trim().replace(/^0+/, '')
                : verCode.value.trim()
    }

    try {
      let response = await FetchWrapper.fetch(config.endpoint_authenticate_participant_lead, {
        method: 'post',
        headers: {
          'Content-Type': 'application/json',
        },
        credentials: 'include',
        body: JSON.stringify(params)
      })

      this.setState({
        verError: false,
        verErrorMessage: ''
      })
      return response.data
    } catch(error) {
      let errormessage = ''
      if(error.statusCode === 406) {
        errormessage = error.message
      }
      this.setState({
        verError: error.statusCode || true,
        verErrorMessage: errormessage  
      })
      return false
    }
  }

  async _isEligible(input) {
    const code = queryString.parse(this.props.location.search)
    if (input.gender.value === 'male') {
      input.health.value.pregnant = false
      input.health.value['pregnant-diabetes'] = false
      input.health.value['baby-weight'] = false
      input.health.value['drink-female'] = false
    }
    else if (input.gender.value === 'female') {
      input.health.value['drink-male'] = false
    }
    const params = {
      regCode: code.regCode,
      answers: {
        gender: input.gender.value, 
        waistSize: parseInt(input.waist.value), 
        height: parseInt(input.height.value), 
        weight: parseInt(input.weight.value), 
        health: JSON.stringify(input.health.value)
      },
      plId: queryString.parse(window.location.search).plId
    }
    try {
      let response = await FetchWrapper.fetch(config.endpoint_get_screener_configuration, {
        method: 'post',
        headers: {
          'Content-Type': 'application/json',
        },
        credentials: 'include',
        body: JSON.stringify(params)
      })

      const { data } = response
      if (data.eligible === 'true') return true
    }
    catch(error) {
    }
    return false
  }

  async _verifyEmail(history, plId) {
    const { email } = history.location.state
    plId = plId === null ? queryString.parse(window.location.search).plId : plId
    try {
      let response = await FetchWrapper.fetch(config.endpoint_verify_unique_email + '&plId=' + plId + '&email=' + email.value.trim(), {
        method: 'get',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include'
      })
      this.setState({
        verError: false
      })
      if (response.status !== 'success') {
        this.setState({
          verError: true,
          verErrorMessage: 'DuplicateEmail'  
        })
        return false
      }
      return true
    } catch(error) {
      this.setState({
        verError: true,
        verErrorMessage: 'DuplicateEmail'  
      })
      return false
    }
  }

  async collectEmail(history, plId) {
    const { email } = history.location.state
    try {
      let params = {
        plId: parseInt(plId),
        email: email.value.trim()
      }
      let response = await FetchWrapper.fetch(config.endpoint_collectEmail, {
        method: 'post',
        headers: {
          'Content-Type': 'application/json',
        },
        credentials: 'include',
        body: JSON.stringify(params)
      })

      const { status } = response
      if(status !== 'success') {
        this.setState({
          nextDisabled: false
        })
      }
      this.setState({ 
        verError: false
      })  
      return true
    } catch(error) {
      this.setState({ 
        nextDisabled: false,
        verError: true 
      })
      return false
    }
  }

  async processRegistration(state, history) {
    const { input } = state

    let discloseHealth = false
    if ((input.discloseHealth && input.discloseHealth.value === 'agree') || (input.discloseHealthCheck && input.discloseHealthCheck.value)) {
      discloseHealth = true
    }

    let discloseHealthInitial = ''
    
    if (input.discloseHealthInitial && ((input.discloseHealth && input.discloseHealth.value === 'agree') || (input.discloseHealthCheck && input.discloseHealthCheck.value))) {
      discloseHealthInitial = input.discloseHealthInitial.value
    }

    let customConsent = false
    if ((input.customConsent && input.customConsent.value === 'agree') || (input.customConsentCheck && input.customConsentCheck.value)) {
      customConsent = true
    }
    let customConsentInitial = ''
    if (input.customConsentInitial && ((input.customConsent && input.customConsent.value === 'agree') || (input.customConsentCheck && input.customConsentCheck.value))) {
      customConsentInitial = input.customConsentInitial.value
    }

    let historyState = history.location.state

    let isDST = false

    let firstName = ''
    let lastName = ''

    if (!this.props.UseNameForVerification || (this.props.UseEmployeeSpouseSelection && historyState.spouseSelection.value === 'true')) {
      firstName = historyState.fName2.value.trim()
      lastName = historyState.lName2.value.trim()
    } else {
      firstName = historyState.fName.value.trim()
      lastName = historyState.lName.value.trim()
    }

    if (historyState.isDST && historyState.isDST.value === 'true') isDST = true
    let answers = null
    try {
      answers = {
        AddressLine1: historyState.address1.value,
        AddressLine2: historyState.address2.value,
        AddressCity: historyState.city.value,
        DateOfBirth: moment(this.parseDob(historyState.dob.value)).toISOString(),
        EmailAddress: historyState.email.value,
        FirstName: firstName,
        VerificationCode: historyState.verCode.value.trim(),
        LastName: lastName,
        PhoneBestNumber: this.formatPhoneNumber(historyState.phone.value),
        MobilePhoneBestNumber: this.formatPhoneNumber(historyState.mobilePhone.value),
        RegistrationCode: historyState.rCode.value.trim(),
        AddressState: historyState.state.value,
        AddressZip: (historyState.country.value === 'USA' ? historyState.zip.value : historyState.postal.value).split(' ').join(''),
        country: historyState.country.value,
        ExpressConsentCSA: input.policyCheck.value,
        ExpressConsentDisclosure: discloseHealth,
        Timezone: historyState.timezone.value,
        isDST: isDST,
        smsOptIn: historyState.smsOptIn.value,
        Reg_Portal_Version: 'v' + versionFile.version + '.' + versionFile.build,
        DisclosureConsentInitials: discloseHealthInitial,
        expressCustomConsent: customConsent,
        customConsentInitials: customConsentInitial
      }
    } catch(error) {
      this.setState({
        nextDisabled: false,
        verError: true
      })
      return false
    }
    
    try { 
      const code = queryString.parse(history.location.search)
      let params = {
        plId: parseInt(code.plId),
        answers,
        NextStepUrl: window.location.origin
      }
      let response = await FetchWrapper.fetch(config.endpoint_process_registration, {
        method: 'post',
        headers: {
          'Content-Type': 'application/json',
        },
        credentials: 'include',
        body: JSON.stringify(params)
      })

      const { status } = response
      if(status !== 'success') {
        this.setState({
          nextDisabled: false
        })
      }
      this.setState({ 
        verError: false
      })  
      return true
    } catch(error) {
      this.setState({ 
        nextDisabled: false,
        verError: true 
      })
      return false
    }
  }

  parseDob(dob) {
    let newDate = dob.split('/').reverse()
    const day = newDate[1]
    newDate[1] = newDate[2]
    newDate[2] = day
    return newDate.join('-')
  }

  setHistory(state, history) {
    const newHistory = { 
      ...history.location.state,
      ...state.input
    }
    return newHistory
  }

  _replaceHistoryState(state, history) {
    const newHistory = this.setHistory(state, history)
    history.replace(history.location.pathname + history.location.search, newHistory)
  }

  formatPhoneNumber(number) {
    let newPhoneNumber = number.replace(/[() -]/g, '')
    newPhoneNumber = newPhoneNumber.replace(/(\d{3})(\d{3})(\d{4})/, "$1-$2-$3")
    return newPhoneNumber
  }

  shouldRedirect() {
    if (!this.props.nextStepPath && (window.location.pathname === '/register/2' || window.location.pathname === '/register/3')) {
      return false
    } else if (window.location.pathname === '/register/1') {
      return false
    }
    return true
  }

  extendRoute(R) {
    return props => {
      return <R 
        {...props} 
        updateActivePage={this.updateActivePage}
        back={this._backPage.bind(this, props.history)}
        next={this._nextPage.bind(this, props.history)}
        getRegistrationConfig={this.getRegistrationConfig}
        getClientData={this.props.getClientData}
        authentication={this.authentication}
        verifyEmail={this.verifyEmail}
        isEligible={this.isEligible}
        collectEmail={this.props.collectEmail}
        UseVerificationCode={this.props.UseVerificationCode}
        UseDOBForVerification={this.props.UseDOBForVerification}
        UseNameForVerification={this.props.UseNameForVerification}
        VerificationPageDescription={this.props.VerificationPageDescription}
        UseLeadingZeros={this.props.UseLeadingZeros}
        VerificationPageInstructions={this.props.VerificationPageInstructions}
        VerificationPageTitle={this.props.VerificationPageTitle}
        UseEmployeeSpouseSelection={this.props.UseEmployeeSpouseSelection}
        SelectEmployeeButtonLabel={this.props.SelectEmployeeButtonLabel}
        SelectSpouseButtonLabel={this.props.SelectSpouseButtonLabel}
        ValidateOn={this.props.ValidateOn}
        verError={this.state.verError}
        verErrorMessage={this.state.verErrorMessage}
        replaceHistoryState={this.replaceHistoryState}
      />
    }
  }

  render() {
    if (this.state.loading) return <div></div>
    return (
      <div id="registration">
        <NextDisabledContext.Provider value={this.state.nextDisabled}>
          <Router basename={this.props.match.path}>
            <Switch>
              <Route path="/1" render={this.extendRoute(Registration1)} />
              <Route path="/2" render={this.extendRoute(Registration3)} />
              <Route path="/assessment" render={this.extendRoute(AssessmentJPMC)} />
              <Route path="/screener" render={this.extendRoute(Screener)} />
              <Route path="/3" render={this.extendRoute(Registration4)} />
            </Switch>
          </Router>
        </NextDisabledContext.Provider>
      </div>
        
    )
  }
}

Registration.contextType = PaginationContext

export default Registration